import { importProvidersFrom, inject, provideEnvironmentInitializer } from "@angular/core";
import {
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
  SoftlineEntityService,
  SoftlineObjectService,
  Store,
  StoreModule
} from "@softline/core";
import {default as de} from './../i18n/de.json';
import {SOFTLINE_FEATURE_TRANSLATION, TranslationStore} from "@softline/ui-core";
import {ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS} from "@softline/application";
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { kommissionierungRoutes } from './kommissionierung.routes';
import { provideKommissionierungGlobals } from './kommissionierung.globals';
import {LlrKommissionierungStore} from "./store/kommissionierung.store";
import {
  SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG,
  SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG_BESTELLUNG,
  SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG_EMBALLAGE,
  SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG_PALETTE,
  SOFTLINE_PERMISSION_LLR_KOMMISSIONIERUNG
} from "./kommissionierung.shared";
import {
  SOFTLINE_API_LLR_KOMMISSIONIERUNG,
  SOFTLINE_API_LLR_KOMMISSIONIERUNG_BESTELLUNGEN,
  SOFTLINE_API_LLR_KOMMISSIONIERUNG_EMBALLAGEN,
  SOFTLINE_API_LLR_KOMMISSIONIERUNG_PALETTEN
} from "./kommissionierung.api";
import {LlrBestellungStore} from "./store/bestellung.store";
import {BestellungService} from "./services/bestellung-service";
import {KommissionierungService} from "./services/kommissionierung-service";
import {LlrPalleteStore} from "./store/palette.store";
import {LlrEmballageStore} from "./store/emballage.store";
import {EmballageService} from "./services/emballage-service";
import {PaletteService} from "./services/palette-service";
import {RemoteConfigService} from "./services/remote-config.service";
import { LeaveArtikelAuswahlGuard } from './guards/leave-artikel-auswahl.guard';
import { LeaveBestellungenGuard } from './guards/leave-bestellungen.guard';

export const kommissionierungProviders = [
  provideEnvironmentInitializer(async () => {
      const store = inject(Store);

      store.commit(
        SOFTLINE_FEATURE_TRANSLATION,
        TranslationStore.mutations.add,
        {
          module: 'llrKommissionierung',
          language: 'de',
          translations: de,
        }
      );

      store.commit(
        SOFTLINE_FEATURE_APPLICATIONS,
        ApplicationStore.mutations.add,
        {
          name: 'Warenzugang',
          route: '/llr-bskomm',
          icon: 'fa-regular fa-boxes-stacked',
          permission: SOFTLINE_PERMISSION_LLR_KOMMISSIONIERUNG
        }
      );
    }),
  importProvidersFrom(
    StoreModule.forFeature({
      feature: LlrKommissionierungStore.feature,
      name: SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG,
      providers: [
        {
          provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
          useFactory: () => new SoftlineObjectService(
            inject(SOFTLINE_SERVICE_HTTP),
            SOFTLINE_API_LLR_KOMMISSIONIERUNG
          )
        }
      ]
    }),
    StoreModule.forFeature({
      feature: LlrBestellungStore.feature,
      name: SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG_BESTELLUNG,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: () => new SoftlineEntityService(
            inject(SOFTLINE_SERVICE_HTTP),
            SOFTLINE_API_LLR_KOMMISSIONIERUNG_BESTELLUNGEN
          )
        }
      ]
    }),
    StoreModule.forFeature({
      feature: LlrPalleteStore.feature,
      name: SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG_PALETTE,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: () => new SoftlineEntityService(
            inject(SOFTLINE_SERVICE_HTTP),
            SOFTLINE_API_LLR_KOMMISSIONIERUNG_PALETTEN
          )
        }
      ]
    }),
    StoreModule.forFeature({
      feature: LlrEmballageStore.feature,
      name: SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG_EMBALLAGE,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: () => new SoftlineEntityService(
            inject(SOFTLINE_SERVICE_HTTP),
            SOFTLINE_API_LLR_KOMMISSIONIERUNG_EMBALLAGEN
          )
        }
      ]
    })
  ),
  BestellungService,
  KommissionierungService,
  EmballageService,
  PaletteService,
  RemoteConfigService,
  LeaveArtikelAuswahlGuard,
  LeaveBestellungenGuard
]

export function provideKommissionierungModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'llrKommissionierung',
        title: 'Warenzugang',
        icon: 'fa-regular fa-boxes-stacked',
        route: '/llr-bskomm',
        permission: SOFTLINE_PERMISSION_LLR_KOMMISSIONIERUNG,
      },
      withSoftAppsModuleRoutes({ app: kommissionierungRoutes }),
      withLazySoftAppsModuleTranslation({
        lazy: { de: () => import('./../i18n/de.json') },
      })
    ),
    ...provideKommissionierungGlobals(),
  ];
}
